var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.3,
    y: 13.3,
    fill: "none",
    width: 3.4,
    height: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M6.5,37.2h31.9v-6.8H37L34.1,15h-3.6v-1.6h1.1c0.7,0.1,1.3-0.5,1.4-1.2c0,0,0-0.1,0-0.1V9 c0-0.7-0.6-1.3-1.3-1.3c0,0-0.1,0-0.1,0h-7.2c-0.7,0-1.3,0.6-1.3,1.3v0.2v2V12c0,0.7,0.6,1.3,1.3,1.3h1.2V15h-5.8V13 c0-0.7-0.6-1.3-1.3-1.3c0,0-0.1,0-0.1,0h-4.2c-0.7-0.1-1.3,0.5-1.4,1.2c0,0,0,0.1,0,0.1V15h-2L8,30.5H6.5V37.2z M21,33.8 c0-0.9,0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6S21,34.7,21,33.8z M23.8,9c0-0.3,0.3-0.6,0.6-0.6h7.2 c0.3,0,0.6,0.3,0.6,0.6V12c0,0.3-0.3,0.6-0.6,0.6h-7.2c-0.3,0.1-0.6-0.2-0.6-0.6V9z M26.3,13.3h3.4V15h-3.4V13.3z M13.5,13 c0-0.3,0.3-0.6,0.6-0.6h4.3c0.3,0,0.6,0.3,0.6,0.6v9.7h-5.5V13z M11.5,15.8h1.4v7h-1.4v0.7h1.4h7h1.4v-0.7h-1.4v-7h13.7l2.8,14.7 H8.6L11.5,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M8.6,30.5h27.7l-2.8-14.7H19.8v7h1.4v0.7h-1.4h-7h-1.4v-0.7h1.4v-7h-1.4L8.6,30.5z M32.5,22.1h-8.7v-4.4 h8.7V22.1z M32.3,27h-1.8v-0.7h1.8V27z M32.3,29.1h-1.8v-0.7h1.8V29.1z M29.1,27h-2v-0.7h2V27z M25.8,24.9h-2v-0.7h2V24.9z  M29.1,24.9h-2v-0.7h2V24.9z M23.8,26.2h2V27h-2V26.2z M23.8,28.3h2v0.7h-2V28.3z M27.1,28.3h2v0.7h-2V28.3z M32.3,24.9h-1.8v-0.7 h1.8V24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M24.5,12.5h7.2c0.3,0,0.6-0.3,0.6-0.6V9c0-0.3-0.3-0.6-0.6-0.6h-7.2c-0.3,0-0.6,0.3-0.6,0.6V12 C23.8,12.3,24.1,12.7,24.5,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M13.5,22.8H19V13c0-0.3-0.3-0.6-0.6-0.6h-4.3c-0.3,0-0.6,0.3-0.6,0.6V22.8z M18.1,18.3v0.7h-3.6v-0.7H18.1z  M14.5,17v-0.7h3.6V17H14.5z M17.5,20.3v0.7H15v-0.7H17.5z M18.1,14.2V15h-3.6v-0.7H18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M23.8,17.8v4.4h8.7v-4.4H23.8z M31.6,18.5v2.9h-7.2v-2.9H31.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 18.5,
    fill: "#C9C9C9",
    width: 7.2,
    height: 2.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.8,
    y: 24.2,
    fill: "#505050",
    width: 2,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 24.2,
    fill: "#505050",
    width: 1.8,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.1,
    y: 24.2,
    fill: "#505050",
    width: 2,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.1,
    y: 26.2,
    fill: "#505050",
    width: 2,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 26.2,
    fill: "#505050",
    width: 1.8,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.8,
    y: 26.2,
    fill: "#505050",
    width: 2,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.8,
    y: 28.3,
    fill: "#505050",
    width: 2,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.1,
    y: 28.3,
    fill: "#505050",
    width: 2,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 28.3,
    fill: "#505050",
    width: 1.8,
    height: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M22.5,35.5c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6S21,33,21,33.8C21,34.7,21.7,35.5,22.5,35.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 14.2,
    fill: "#505050",
    width: 3.6,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 16.2,
    fill: "#505050",
    width: 3.6,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 18.3,
    fill: "#505050",
    width: 3.6,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 20.3,
    fill: "#505050",
    width: 2.5,
    height: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.faed133aafac4159c60f5ba88377f39c.svg";
export { ForwardRef as ReactComponent };